import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import { throttle } from "../../../../../utils/function"
import { joinLobbyRoom } from "../../../game/lobby-logic"
import { useAppDispatch, useAppSelector } from "../../../hooks"
import { logIn, logOut } from "../../../stores/NetworkStore"
// import { FIREBASE_CONFIG } from "../../utils/utils"
import { gitee } from "../../utils/gitee-auth"
import cas from "../../utils/cas-auth"
import GiteeLoginButton from "./gitee-login-button"
import CASDoorLoginButton from "./casdoor-login-button"
//import AnonymousButton from "./anonymous-button"
// import { StyledFirebaseAuth } from "./styled-firebase-auth"
import { GITEE_CONFIG } from "../../utils/utils"

// import "firebaseui/dist/firebaseui.css"
import "./login.css"

export default function Login(props: { giteeCode?: string | null, state?: string | null }) {

  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  let uid = useAppSelector((state) => state.network.uid)
  const displayName = useAppSelector((state) => state.network.displayName)
  const email = useAppSelector((state) => state.network.email)
  const [prejoining, setPrejoining] = useState(false)
  const [switchAccountLoading, setSwitchAccountLoading] = useState(false)
  const giteeEnabled = GITEE_CONFIG.enable;
  // if(giteeTicket){
  //   uid = giteeTicket;
  // } 
  let isGitee = true;
  let code = props.giteeCode
  // console.log("Login props", props)
  console.log("uid, code", uid, displayName)
  let [loginType, setLoginType] = useState("casdoor");

  useEffect(() => {
    if (code && !uid) {
      setLoading(true)
      window.history.replaceState({ path: '/' }, '', '/');
      if (props.state === "casdoor") {
        // 进入这里是casdoor登录，使用code去请求数据库，获取用户信息等
        console.log("casdoor login, state:", props.state)
        // 使用code去请求数据库，获取用户信息等
        setLoading(true)
        window.history.replaceState({ path: '/' }, '', '/');
        cas.getUserByCasdoorCode(code).then(user => {
          console.log("casdoor get user by code result", user)  
          if (user) {
            dispatch(logIn(user))
            console.log("casdoor login success, user:", user)
          }
          setLoading(false)
          setLoginType("casdoor");
        });
      } else {
        // 进入这里是gitee登录，使用code去请求数据库，获取用户信息等
        gitee.getUserByGiteeCode(code).then(user => {
          if (user) {
            dispatch(logIn(user))
          }
          setLoading(false)
          setLoginType("gitee");
        });
      } 

    } else {
      // setLoading(true)
      // gitee.getAndCheckAuth().then(user=>{
      //   if (user) {
      //     dispatch(logIn(user))
      //   }
      //   setLoading(false)
      // });
    }

    return () => {
    };
  }, [code])

  const [loggingOut, setLoggingOut] = useState(false)

  const preJoinLobby = throttle(async function prejoin() {
    setPrejoining(true)
    return joinLobbyRoom(dispatch, navigate)
      .then(() => navigate("/lobby"))
      .catch(() => setPrejoining(false))
  }, 1000)

  // const uiConfig = {
  //   // Popup signin flow rather than Navigate flow.
  //   signInFlow: "popup",
  //   // We will display Google and Facebook as auth providers.
  //   signInSuccessUrl: window.location.href + "lobby",
  //   signInOptions: [
  //     firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  //     {
  //       provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
  //       requireDisplayName: true
  //     },
  //     firebase.auth.TwitterAuthProvider.PROVIDER_ID
  //   ],
  //   callbacks: {
  //     // Avoid Navigates after sign-in.
  //     signInSuccessWithAuthResult: () => true
  //   }
  // }

  // Initialize Firebase
  // if (!firebase.apps.length) {
  //   firebase.initializeApp(FIREBASE_CONFIG)
  // }


  if (!uid) {
    return (
      <div id="play-panel">
        {/* <StyledFirebaseAuth
          uiConfig={uiConfig}
          firebaseAuth={firebase.auth()}
        /> */}
        <CASDoorLoginButton />
        <br /> 
        {giteeEnabled ? <GiteeLoginButton />
        : null }
        <span>{loading && "登录中，请稍候..."}</span>
      </div>
    )
  } else {
    return (
      <div id="play-panel">
        <p>
          {t("auth.authenticated_as")}:{" "}
          <span title={`${displayName}${email ? ` (${email})` : ""}`}>
            {t("auth.hover_to_reveal")}
          </span>
        </p>
        <ul className="actions">
          <li>
            <button
              className="bubbly green"
              onClick={preJoinLobby}
              disabled={prejoining}
            >
              {prejoining ? t("auth.connecting") : t("auth.join_lobby")}
            </button>
          </li>
          <li>
            <button
              className="bubbly yellow"
              onClick={() => {
                setSwitchAccountLoading(true)
                window.history.replaceState({ path: '/' }, '', '/');
                // 切换账号，跳转到gitee页面去退出登录等操作
                gitee.logout();
                try {
                  // dispatch(logOut())
                } finally {
                  setSwitchAccountLoading(false)
                }
                setTimeout(() => {
                  loginType === "casdoor" ? window.location.href = "https://cas.52kx.net/login/52kx_net" :
                  window.location.href = "https://gitee.com/";
                }, 500);
              }}
              disabled={switchAccountLoading || prejoining || loggingOut}
            >
              {switchAccountLoading ? "切换中.." : "切换账号"}
            </button>
          </li>
          <li>
            <button
              className="bubbly red"
              disabled={prejoining || loggingOut}
              onClick={() => {
                gitee.logout();
                window.history.replaceState({ path: '/' }, '', '/');
                // dispatch(logOut()) 
                // setLoggingOut(true)
                try {
                  dispatch(logOut())
                } finally {
                  setLoggingOut(false)
                }
              }}
            >
              {loggingOut ? t("auth.signing_out") : t("auth.sign_out")}
            </button>
          </li>
        </ul>
      </div>
    )
  }
}
